/**
 * @generated SignedSource<<e203410ed3587f60a1647fa1b8346e1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionProductEventDescriptionList_promotion$data = {
  readonly productEvent: {
    readonly durationDays: number | null;
    readonly durationHours: number | null;
    readonly offsetHours: number;
    readonly title: string;
  } | null;
  readonly " $fragmentType": "PromotionProductEventDescriptionList_promotion";
};
export type PromotionProductEventDescriptionList_promotion$key = {
  readonly " $data"?: PromotionProductEventDescriptionList_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionProductEventDescriptionList_promotion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionProductEventDescriptionList_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionProductEvent",
      "kind": "LinkedField",
      "name": "productEvent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationHours",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offsetHours",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};

(node as any).hash = "1122cd0f6655bc5e9faa242abb3b3415";

export default node;
